import React, { useState, useEffect } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { education } from "../details/data";
import "../styles/Education.css";

function EducationContent({
  img,
  place,
  time,
  grade,
  desc,
  deg,
  last,
  alternate,
}) {
  return (
    <>
    <TimelineItem>
      <TimelineSeparator className="timeLine">
        <TimelineDot color="inherit">
          <img
            src={img}
            alt="company"
            className="timeLineImg"
            style={{
              width: alternate ? "50px" : "30px",
              height: alternate ? "50px" : "30px",
              borderRadius: "50%",
            }}
            />
        </TimelineDot>
        {!last && <TimelineConnector />}
      </TimelineSeparator>
      <TimelineContent>
        <div className="timeLineEduContent">
          <div className="eduTopContent">
            <div className="eduTopLeft">
              <img src={img} alt={place} className="eduImage" />
            </div>
            <div className="eduTopRight">
              <h2 className="eduPlace">{place}</h2>
              <p className="eduName">{deg}</p>
              <p className="eduTime">{time}</p>
            </div>
          </div>
          <div className="extra">
            <h4>Grade: </h4>
            <span>{grade}</span>
          </div>
          <div className="eduMainContent">
            <p className="educationDesc">{desc}</p>
          </div>
        </div>
      </TimelineContent>
    </TimelineItem>
</>
  );
}

const Education = () => {
  const [alternate, setAlternate] = useState({
    width: window.innerWidth,
    alter: window.innerWidth > 1200,
  });
  useEffect(() => {
    const resize = () => {
      setAlternate({
        width: window.innerWidth,
        alter: window.innerWidth > 1200,
      });
    };
    window.onresize = resize;

    return () => {
      window.onresize = null;
    };
  }, []);
  return (
    <section id="education" className="education">
      <div className="educationHeader">
        <h1>Education</h1>
        <p>
          My education has been a journey of self-discovery and growth. My
          educational details are as follows.
        </p>
      </div>
      <div className="educationContent">
        {!alternate.alter ? (
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
              },
            }}
          >
            {education.map((course) => (
              <EducationContent
                img={course.img}
                deg={course.degree}
                desc={course.desc}
                grade={course.grade}
                place={course.school}
                time={course.date}
                key={course.id}
                last={course.id + 1 === education.length}
                alternate={alternate}
              />
            ))}
          </Timeline>
        ) : (
          <Timeline position="alternate">
            {education.map((course) => (
              <EducationContent
                img={course.img}
                deg={course.degree}
                desc={course.desc}
                grade={course.grade}
                place={course.school}
                time={course.date}
                key={course.id}
                last={course.id + 1 === education.length}
                alternate={alternate}
              />
            ))}
          </Timeline>
        )}
      </div>
    </section>
  );
};

export default Education;
